import React from 'react'; // eslint-disable-line
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import UploadPicture from '../svg/Image';
import i18n from '../../i18n';
import LargeLoading from '../svg/LargeLoading';

class DragAndDrop extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            uploadInputValue: '',
            uploading: false,
        };
    }

    componentDidMount() {
        window.addEventListener('mouseup', this.onDragLeave);
        window.addEventListener('dragenter', this.onDragEnter);
        window.addEventListener('dragover', this.onDragOver);
        document.getElementById('dropZone')
            .addEventListener('dragleave', this.onDragLeave);
        window.addEventListener('drop', this.onDrop);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.clearUploading === false && this.props.clearUploading === true) {
            // eslint-disable-next-line
            this.setState({ uploading: false });
            this.props.clearUploadAction();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('mouseup', this.onDragLeave);
        window.removeEventListener('dragenter', this.onDragEnter);
        window.addEventListener('dragover', this.onDragOver);
        document.getElementById('dropZone')
            .removeEventListener('dragleave', this.onDragLeave);
        window.removeEventListener('drop', this.onDrop);
    }

    handleChosenImage = (fileUploader) => {
        if (this.props.handleChosenImage) {
            this.props.handleChosenImage(fileUploader.files[0]);
        }
        this.setState({
            uploadInputValue: '',
            uploading: true,
        });
    }

    onDragEnter = (e) => {
        e.stopPropagation();
        e.preventDefault();
        return false;
    }

    onDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        return false;
    }

    onDragLeave = (e) => {
        e.stopPropagation();
        e.preventDefault();
        return false;
    }

    onDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        this.props.dropImage(file);
        this.setState({ uploading: true });
    }

    render() {
        return (
            <div className="asset-upload" id="dropZone">
                <div>
                    {this.state.uploading === true
                        ? (
                            <div id="loading-page">
                                <div id="loading-container_loader">
                                    <LargeLoading />
                                </div>
                            </div>
                        )
                        : <UploadPicture />}
                </div>
                { !this.state.uploading
                && (
                    <h6>
                        <FontAwesomeIcon icon={['fas', 'arrow-from-bottom']} />
                        {' '}
                        {i18n.t('upload.drag-title')}
                        {' '}
                        {i18n.t('or')}
                        {' '}
                        <a onClick={() => { return this.props.chooseFile(this.refs.fileUploader); }}>
                            {i18n.t('upload.browse')}
                        </a>
                    </h6>
                )}
                { !this.state.uploading
                    && (
                        <h6>
                            Minimum Image Size:
                            {this.props.width}
                            {' '}
                            x
                            {this.props.height}
                        </h6>
                    )}
                { !this.state.uploading
                && (
                    <p className="btn-wrapper text-center">
                        { /* eslint-disable */}
                    <input
                        id="upload"
                        type="file"
                        accept={this.props.data?.fileDialogTypes}
                        value={this.state.uploadInputValue}
                        onChange={() => { return this.handleChosenImage(this.refs.fileUploader); }}
                        ref="fileUploader"
                        style={{ display: 'none' }}
                    />
                    { /* eslint-enable */}
                    </p>
                ) }
            </div>
        );
    }
}

export default DragAndDrop;
